import { createFilterStore } from './createFilterStore';

export const useInvoiceFilterStore = createFilterStore({
  page: 1,
  limit: 20,
  search: '',
  status: '',
  // Newest document first by its own date — not by when the row was
  // entered, which puts a back-dated document on top of the list.
  sortBy: 'issueDate',
  sortOrder: 'desc' as const,
});
